import { jsx as o } from "react/jsx-runtime";
import s from "./index.es5597.js";
import { ChipGoToIcon as p } from "./index.es5598.js";
import { ChipEditIcon as e } from "./index.es5599.js";
import { ChipCloseIcon as n } from "./index.es815.js";
import m from "classnames";
const h = {
  goto: /* @__PURE__ */ o(p, {}),
  close: /* @__PURE__ */ o(n, {}),
  edit: /* @__PURE__ */ o(e, {})
}, l = ({ actionVariant: i, onClick: t }) => /* @__PURE__ */ o(
  "button",
  {
    tabIndex: 0,
    onClick: (r) => {
      r.stopPropagation(), t();
    },
    className: s["chip--hover-action"],
    "data-testid": `${i}-action`,
    "aria-label": `${i} action`,
    children: h[i]
  }
), A = ({ actions: i, className: t }) => /* @__PURE__ */ o("div", { className: m(s["chip--hover-actions"], t), children: i.map(({ actionVariant: c, onClick: r }) => /* @__PURE__ */ o(l, { actionVariant: c, onClick: r }, c)) });
export {
  A as ChipActions
};
//# sourceMappingURL=index.es814.js.map
